import React, { useContext, useState } from 'react';

import { IAppConfig } from 'src/services/app-config';
import { MayBe } from 'src/types';

export const AppConfigContext = React.createContext<MayBe<IAppConfig>>(null);

export const SetAppConfigContext = React.createContext<React.Dispatch<React.SetStateAction<MayBe<IAppConfig>>>>(
  () => null,
);

export const useAppConfig = () => useContext(AppConfigContext);

export const useSetAppConfig = () => useContext(SetAppConfigContext);

export const AppProvider: React.FC = ({ children }) => {
  const [user, setApp] = useState<MayBe<IAppConfig>>(null);
  return (
    <AppConfigContext.Provider value={user}>
      <SetAppConfigContext.Provider value={setApp}>{children}</SetAppConfigContext.Provider>
    </AppConfigContext.Provider>
  );
};
